import * as React from 'react';
import { SvgWrapper } from '../utils';
import type { IconProps } from '../utils';

const svg = (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 41 41" width="1em" height="1em">
    <g data-name="Layer 2">
      <g data-name="Layer 1">
        <path
          strokeWidth={1}
          stroke="fj-icons-primary-color"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="fj-icons-bg-color"
          d="M.5.5h40v28.21H.5z"
        />
        <path fill="fj-icons-primary-color" d="M17.5 28.84h6v11.67h-6z" />
        <path
          strokeWidth={1}
          stroke="fj-icons-primary-color"
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M9.67 40.5h21.66"
        />
        <path
          d="M15.69 25v-4.53a3.78 3.78 0 00-4-3.52H9.14a3.77 3.77 0 00-4 3.52V25z"
          strokeWidth={0.78}
          stroke="fj-icons-primary-color"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="fj-icons-bg-color"
        />
        <ellipse
          cx={10.43}
          cy={13.34}
          rx={3.85}
          ry={3.82}
          strokeWidth={0.78}
          stroke="fj-icons-primary-color"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="fj-icons-bg-color"
        />
        <path
          d="M36.36 25.11v-4.79a4 4 0 00-4.15-3.68h-2.7a4 4 0 00-4.16 3.68v4.79z"
          strokeWidth={0.78}
          stroke="fj-icons-primary-color"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="fj-icons-bg-color"
        />
        <ellipse
          cx={30.86}
          cy={12.85}
          rx={4.03}
          ry={4}
          strokeWidth={0.78}
          stroke="fj-icons-primary-color"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="fj-icons-bg-color"
        />
        <path
          d="M25.91 25.11V19.2a4.87 4.87 0 00-5.12-4.55h-3.34c-2.82 0-5.13 2-5.13 4.55v5.91z"
          strokeWidth={0.78}
          stroke="fj-icons-primary-color"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="fj-icons-bg-color"
        />
        <ellipse
          cx={19.12}
          cy={9.97}
          rx={4.98}
          ry={4.94}
          strokeWidth={0.78}
          stroke="fj-icons-primary-color"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="fj-icons-bg-color"
        />
      </g>
    </g>
  </svg>
);

const SharedComputers = ({
  style = {
    primaryColor: 'currentColor',
    bgColor: 'transparent',
  },
  size = '1em',
  active = false,
  ...rest
}: IconProps) => (
  <SvgWrapper style={style} size={size} active={active} {...rest}>
    {svg}
  </SvgWrapper>
);

export default SharedComputers;
